import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ customBreadcrumbs = null }) => {
  const location = useLocation();

  const routeLabels = {
    '/homepage': 'Accueil',
    '/lycee-orientation': 'Orientation Lycée',
    '/post-bac-database': 'Écoles & Universités',
    '/institution-details': 'Détails de l\'établissement',
    '/admission-calendar': 'Calendrier',
    '/student-profile': 'Mon Profil'
  };

  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) {
      return customBreadcrumbs;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(segment => segment);
    const breadcrumbs = [{ label: 'Accueil', path: '/homepage' }];

    if (pathSegments?.length > 0) {
      let currentPath = '';
      pathSegments?.forEach((segment, index) => {
        currentPath += `/${segment}`;
        const label = routeLabels?.[currentPath] || segment?.charAt(0)?.toUpperCase() + segment?.slice(1);
        
        if (currentPath !== '/homepage') {
          breadcrumbs?.push({
            label,
            path: currentPath,
            isLast: index === pathSegments?.length - 1
          });
        }
      });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Fil d'ariane">
      {breadcrumbs?.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb?.path}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-muted-foreground/60" />
          )}
          {breadcrumb?.isLast ? (
            <span className="text-foreground font-medium" aria-current="page">
              {breadcrumb?.label}
            </span>
          ) : (
            <Link
              to={breadcrumb?.path}
              className="hover:text-primary transition-smooth"
            >
              {breadcrumb?.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default BreadcrumbNavigation;